import { Price, Token } from 'eth-mainnet-few-sdk-core-2'
import { tickToPrice } from 'eth-mainnet-few-v3-sdk-2'

export function getTickToPrice(baseToken?: Token, quoteToken?: Token, tick?: number): Price<Token, Token> | undefined {
  if (!baseToken || !quoteToken || typeof tick !== 'number') {
    return undefined
  }
  return tickToPrice(baseToken, quoteToken, tick)
}
